import { Subject } from "rxjs";

export class DialogService {
  private closeDialogSubject = new Subject<void>();

  closeDialog() {
    this.closeDialogSubject.next();
  }

  onCloseDialog() {
    return this.closeDialogSubject.asObservable();
  }
}
